import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcaseWork: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSuitcaseWork"><Path d="M21.25 17.25V9.75C21.25 8.09315 19.9069 6.75 18.25 6.75H5.75C4.09315 6.75 2.75 8.09315 2.75 9.75V17.25C2.75 18.9069 4.09315 20.25 5.75 20.25H18.25C19.9069 20.25 21.25 18.9069 21.25 17.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M7.75 6.75V5.75C7.75 4.09315 9.09315 2.75 10.75 2.75H13.25C14.9069 2.75 16.25 4.09315 16.25 5.75V6.75" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSuitcaseWork;
